import React from 'react';
import { ErrorPalette, SuccessPalette } from '@tcl-boron-colors/colors';
import { Fail, Success } from '@tcl-boron-icons/icons';
import { Button } from '@tcl-boron-prefabs/button';
import { FA_MESSAGE_CONFIG } from './config';
import { FinancialAssistanceStatuses } from 'requisition-service-shared';
import standaloneStyles from '../shared/standalone-styles.module.css';

export const NeuroFinancialAssistanceSubmitted: React.FC<{
  approvalStatus?: FinancialAssistanceStatuses;
  referenceId?: string;
}> = ({ approvalStatus, referenceId }) => {
  if (!approvalStatus) {
    return null;
  }

  const config = FA_MESSAGE_CONFIG[approvalStatus as string];

  if (!config) {
    return null;
  }

  return (
    <div className={standaloneStyles.content} style={{ textAlign: 'center' }}>
      <div className={standaloneStyles.statusContainer}>
        {config.icon}
        <p className={standaloneStyles.subtitle} style={{ margin: 0 }}>
          <strong>{config.title}</strong>
        </p>
      </div>
      <p className={standaloneStyles.subtitle}>{config.message}</p>
      {referenceId && (
        <p className={standaloneStyles.subtitle}>
          Form Reference ID: <strong>{referenceId}</strong>
        </p>
      )}
      <a href="/form/neurology/consent">
        <Button ariaLabel="Back to Consent">Back to Consent</Button>
      </a>
    </div>
  );
};

export const NeuroFinancialAssistanceAlreadySubmitted: React.FC<{ referenceId?: string }> = ({ referenceId }) => (
  <div className={standaloneStyles.content} style={{ textAlign: 'center' }}>
    <div className={standaloneStyles.statusContainer}>
      <Success color={SuccessPalette[700]} />
      <p className={standaloneStyles.subtitle} style={{ margin: 0 }}>
        <strong>Financial Assistance Already Submitted</strong>
      </p>
    </div>
    <p className={standaloneStyles.subtitle}>
      You have already submitted your financial assistance request. If you have any questions, please contact our Tempus
      Customer Success team at <a href="mailto:help@tempus.com">help@tempus.com</a> or call{' '}
      <a href="tel:312-598-9961">312-598-9961</a>.
    </p>
    {referenceId && (
      <p className={standaloneStyles.subtitle}>
        Form Reference ID: <strong>{referenceId}</strong>
      </p>
    )}
    <a href="/form/neurology/consent">
      <Button ariaLabel="Back to Consent">Back to Consent</Button>
    </a>
  </div>
);

export const NeuroFinancialAssistanceSubmissionError: React.FC<{ onRetry: () => void; referenceId?: string }> = ({
  onRetry,
  referenceId,
}) => (
  <div className={standaloneStyles.content} style={{ textAlign: 'center' }}>
    <div className={standaloneStyles.statusContainer}>
      <Fail color={ErrorPalette[700]} />
      <p className={standaloneStyles.subtitle} style={{ margin: 0 }}>
        <strong>Submission Error</strong>
      </p>
    </div>
    <p className={standaloneStyles.subtitle}>
      Your Financial Assistance application ran into an error. Please try re-submitting your application. If this issue
      persists, please contact the Tempus Customer Success team at <a href="mailto:help@tempus.com">help@tempus.com</a>{' '}
      or call <a href="tel:312-598-9961">312-598-9961</a>.
    </p>
    {referenceId && (
      <p className={standaloneStyles.subtitle}>
        Form Reference ID: <strong>{referenceId}</strong>
      </p>
    )}
    <div style={{ alignSelf: 'center' }}>
      <Button ariaLabel="Retry" onClick={onRetry}>
        Retry
      </Button>
    </div>
  </div>
);
